//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectBodyList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"BlockType",1,0],[0,"GenerateMethod",1,0],[0,"ReferencePoint",1,"Point",0],[0,"RoundDimensionValue",1,0],[0,"RoundPrecision",1,0],[0,"RoundTotalDimension",1,0],[0,"RoundTotalDimensionPrecision",1,0],[1,"SelectWorkPieceBody",0,"SelectBodyList",0],[0,"ShowBoundbox",1,0],[0,"Type",1,0]],[[[],"ResetSizes",{},0,0],[[],"GetWorkPieceData",{R_:{workpieceData:"Tooling.WorkPieceData"}},0,0],[[],"CreateWorkPieceData",{R_:{workpieceData:"Tooling.WorkPieceData"}},0,0],[["partTag","blank"],"SetWorkpiecePartBlankStatus",{},2,0],[["type","workpiecetype"],"InitWorkPieceData",{},0,0],[[],"SetLayoutInfo",{},0,0],[["workpiece"],"UpdateSketchCurves",{},1,0],[["sketchTag","offset"],"UpdateSketchCurvesWhenUsingRefPoint",{},2,0],[["createType","body"],"LinkSketchWorkpieceToShrinkPart",{},2,0],[["extrude"],"SetExtrudeBuilder",{},1,0],[["combinedExtrude"],"SetCombinedExtrudeBuilder",{},1,0],[["newLayer"],"MoveStandardWorkpieceToLayer",{},1,0],[["newLayer"],"MoveWorkpieceSketchToLayer",{},1,0],[["body","boxSize"],"EditWorkpieceUdo",{},2,0],[[],"InsertBlock",{},0,0]],[]];
SPLM.Tooling.WorkpieceBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.WorkpieceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.WorkpieceBuilder.Types = Object.freeze({
    "ProductWorkPiece" : "ProductWorkPiece", "CombinedWorkPiece" : "CombinedWorkPiece"});

SPLM.Tooling.WorkpieceBuilder.WorkPieceType = Object.freeze({
    "UserDefinedBlock" : "UserDefinedBlock", "CavityCore" : "CavityCore", "CavityOnly" : "CavityOnly", "CoreOnly" : "CoreOnly"});

SPLM.Tooling.WorkpieceBuilder.MethodType = Object.freeze({
    "DistanceAllowance" : "DistanceAllowance", "ReferencePoint" : "ReferencePoint", "Sketch" : "Sketch", "KfBox" : "KfBox"});

export default SPLM;